import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import LabelText from "../../../ui/LabelText";
import Switch from "../../../ui/CustomSwitch";
import Pitch from "../../Pitch";
import { IZoneArray } from "../../../types/IPitchProps";
import RadioButton from "../../../ui/CustomRadioButton";
import FilterDropdown from "../../../ui/FilterDropdown";
import NumberTextField from "../../../ui/NumberTextField";
import AlteredIcon from "../../../assets/icons/Altered.png";
import GreenAlteredIcon from "../../../assets/icons/GreenAltered.png";
import { ISectionState, SectionProps } from "../../../types/IPlayerSearchFilter";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IAttribute, ISection } from "./SelectAttributes";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import SelectTags, { ITag } from "./SelectTags";
import PrimaryButton from "../../../ui/PrimaryButton";
import CloseIcon from "@mui/icons-material/Close";
import IApiResponse from "../../../types/IApiResponse";
import { fetchData, postData } from "../../../services/api";
import apiUrls from "../../../config/apiUrls";
import SearchInput from "../../../ui/SearchInput";
import { IPlayerSearchResponse, IPlayerZonePosition } from "../../../types/IPlayerSearchResponse";
import { debounceFunction } from "../../../utils/debounceFunction";
import PlayerSearchList from "./PlayerSearchList";
import { usePlayerSearch } from "../../../contexts/SearchPlayersContext";
import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import { PlayerAvatar } from "../../../styled-components/PlayerCard.Styles";
import { useLoading } from "../../../contexts/LoadingContext";
import { IPositionSearchByZoneResponse } from "../../../types/IPositionSearchByZoneResponse";
import { IPlayerAttributesData } from "../../../types/IPlayerAttributesData";
import PlayerPositionProfile from "./PlayerPositionProfile";
import { attributeSections, positionOptions } from "../../../data/attributeSection";
import {
  AlteredSection,
  AttributesList,
  Foot,
  InitialSearchPlayerList,
  PlayerFilterText,
  PlayerSearchResultsStyled,
  SelectedAttributes,
  SelectedPlayerResult,
} from "../../../styled-components/PlayerComponent.styles";
import { useTheme } from "../../../contexts/ThemeContext";
import {
  fetchAllAreaByRegions,
  fetchAllClubLeagues,
  fetchDataForSearchPlayer,
  fetchPlayerZonePositionData,
} from "../../../services/dataService";
import BarChart from "./BarChart";
import { footLabels, valueSliderData, wagesSliderData } from "../../../data/playerFilterConstants";
import SecondaryButton from "../../../ui/SecondaryButton";
import { useNavigate } from "react-router-dom";
import { getArchetypeColorByValue } from "../../../utils/pitchWidgetUtils";
import ChevronDown from "../../../assets/icons/ChevronDown.png";
import ChevronUp from "../../../assets/icons/ChevronUp.png";
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import { archetypeCircleColors, ArchetypeComparisonChart, ColorBox, IComparisonData } from "../../../pages/Chemistry/UIContentUtils";
import InfoIcon from "../../../assets/icons/infoicon.svg";
import { ArchetypeInfoDrawer } from "../../../pages/Chemistry/UIContent";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import InputFeild from "../../../ui/InputFeild";


interface ISelectedOption {
  region: string;
  optionId: number;
}

export interface IWorksWellWith {
  archetypeId: number;
  archetypeName: string;
  score: number;
  footprintPscore: { [key: string]: number | null };
  footprintRaw: { [key: string]: number | null };
}

export interface ITypicalPlayerExample {
  playerId: number;
  shortName: string;
  imageUrl: string;
  teamName: string;
}

export interface IArchetypeInfo {
  archetypeId: number;
  archetypeName: number;
  typicals: ITypicalPlayerExample[];
  worksWells: IWorksWellWith[];
  highOn: [];
  lowOn: [];
  selectedPscore: { [key: string]: number | null };
  selectedRaw: { [key: string]: number | null };
  footPrints: IWorksWellWith[];
}



const Section: React.FC<SectionProps> = ({ label, isOpen, toggle, children }) => (
  <AlteredSection className="player-filter-section" style={{ width: '105%' }}>
    <div className="player-filters-sub-header" onClick={toggle}>
      <LabelText className="player-search-text">{label}</LabelText>
      <div className="section-right">
        {isOpen && label === "Top percentiles" && (
          <InfoOutlinedIcon
            className="icon"
            onClick={() => {
              //console.log(true);
            }}
          />
        )}
        {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </div>
    </div>
    {isOpen && children}
  </AlteredSection>
);

const PlayerSearchInit = () => {
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoading();
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSelectedPlayer,
    selectedTags,
    handleSelectedTags,
    selectedPlayers,
    tagsDrawerOpen,
    setTagsDrawerOpen,
    setIsAllPosition,
    setPlayerSearchResultsVisible,
    regionAreaData,
    handleRegionAreaData,
    clubLeagueData,
    handleClubLeagueData,
    handleSelectedAttributes,
    setIsSearchByAttributes,
    setIsAltered,
    isAltered,
    handleSelectedPlayerZones,
    selectedPlayerZones,
    handleSelectedProfiles,
    selectedProfiles,
    setSelectedProfiles,
    selectedAttributesState,
    setTransferValue,
    setTrueValue,
    setContractUntilValue,
    setWagesValue,
    setAgeRange,
    setMinAppearances,
    setStartsOnly,
    setFoot,
    setCompetitionValues,
    setRegionValues,
    setIsExactMatchesOnly,
    setPlayerInitialAttributes,
    setAllProfiles,
    isAllPosition,
    allProfiles,
    handleSelectedPlayerAttributes,
    selectedPlayerAttributes,
    transferValue,
    trueValue,
    contractUntilValue,
    wagesValue,
    ageRange,
    minAppearances,
    startsOnly,
    foot,
    competitionValues,
    regionValues,
    isExactMatchesOnly,
    setIsPlayerFilterChange,
    filters,
    handleFilterChange,
    isButtonDisabled,
  } = usePlayerSearch();
  const { theme } = useTheme();
  const [selectedAreas, setSelectedAreas] = useState<number[]>(selectedPlayerZones ?? []);
  const [selectedOption, setSelectedOption] = useState<string>(isAllPosition ?? "allpositions");
  const [sectionsState, setSectionsState] = useState<ISection[]>(
    selectedPlayerAttributes.length > 1 ? selectedPlayerAttributes : attributeSections
  );
  const [playerTransferValue, setPlayerTransferValue] = useState<{ min: number; max: number }>(transferValue ?? { min: 0, max: 250000000 });
  const [playerTrueValue, setPlayerTrueValue] = useState<{ min: number; max: number }>(trueValue ?? { min: 0, max: 250000000 });
  const [playerContractUntilValue, setPlayerContractUntilValue] = useState<{ min: number; max: number }>(
    contractUntilValue ?? { min: 0, max: 120 }
  );
  const [playerWagesValue, setPlayerWagesValue] = useState<{ min: number; max: number }>(wagesValue ?? { min: 0, max: 180000000 });
  const [playerAgeRange, setPlayerAgeRange] = useState<{ min: number; max: number }>(ageRange ?? { min: 16, max: 50 });
  const [playerMinAppearances, setPlayerMinAppearances] = useState<number>(minAppearances ?? 0);
  const [playerStartsOnly, setPlayerStartsOnly] = useState<boolean>(startsOnly ?? true);
  const [selectedFootOptions, setSelectedFootOptions] = useState<number[]>(foot ?? []);
  const [playerCompetition, setPlayerCompetition] = useState<ISelectedOption[]>(competitionValues ?? []);
  const [playerRegion, setPlayerRegion] = useState<ISelectedOption[]>(regionValues ?? []);
  const [selectedPlayerTags, setSelectedPlayerTags] = useState<ITag[]>(selectedTags ?? []);
  const [isPlayerSearch, setIsPlayerSearch] = useState<boolean>(selectedPlayers.length > 0 ? true : false);
  const [clearInput, setClearInput] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [searchPlayerData, setSearchPlayerData] = useState<IPlayerSearchResponse[]>(selectedPlayers ?? []);
  const [selectedItems, setSelectedItems] = useState<IPlayerSearchResponse[]>([]);
  const [zonePositionList, setZonePositionList] = useState<IPositionSearchByZoneResponse[]>(allProfiles ?? []);
  const [selectedProfileItems, setSelectedProfileItems] = useState<IPositionSearchByZoneResponse[]>(
    allProfiles.filter((profile) => selectedProfiles.includes(profile.positionId)) ?? []
  );
  const [isOpen, setIsOpen] = useState<ISectionState>({
    tags: false,
    financial: false,
    statistical: false,
    status: false,
    region: false,
    clubleague: false,
    Preferredfoot: false,
    toppercentiles: false,
  });
  const [isExactMatch, setIsExactMatch] = useState<boolean>(isExactMatchesOnly ?? false);
  const [initialAttributeSections, setInitialAttributeSections] = useState<ISection[]>(
    selectedPlayerAttributes.length > 1 ? selectedPlayerAttributes : []
  );
  const [txtInputWidth, settxtInputWidth] = useState(playerMinAppearances ? Math.max(50, playerMinAppearances.toString().length * 20) : 50);
  const [activeArchetypeID, setActiveArchetypeID] = useState<number>(0);
  const [archetypeID, setArchetypeID] = useState<number>(0);
  const { setSelectedPositionIds } = useSearch()
  const [activeArchetypeName, setActiveArchetypeName] = useState<string>('');


  useEffect(() => {
    const fetchRegionAreaData = async () => {
      if (regionAreaData.length === 0) {
        try {
          startLoading();
          const areaResponse = await fetchAllAreaByRegions();
          if (areaResponse.isSuccess) {
            handleRegionAreaData(areaResponse.data);
          } else {
            console.error("Failed to fetch area data:", areaResponse);
          }
        } catch (error) {
          console.error("Error fetching region area data:", error);
        } finally {
          stopLoading();
        }
      }
    };
    fetchRegionAreaData();
  }, [regionAreaData]);

  useEffect(() => {
    const fetchClubLeagueData = async () => {
      if (clubLeagueData.length === 0) {
        try {
          startLoading();
          const leagueResponse = await fetchAllClubLeagues();
          if (leagueResponse.isSuccess) {
            handleClubLeagueData(leagueResponse.data);
          } else {
            console.error("Failed to fetch club league data:", leagueResponse);
          }
        } catch (error) {
          console.error("Error fetching club league data:", error);
        } finally {
          stopLoading();
        }
      }
    };
    fetchClubLeagueData();
  }, [clubLeagueData]);

  const arraysEqual = (arr1: number[], arr2: number[]): boolean => {
    if (arr1.length !== arr2.length) return false;
    return arr1
      .slice()
      .sort()
      .every((value, index) => value === arr2.slice().sort()[index]);
  };

  const areAttributesEqual = (arr1: IAttribute[], arr2: IAttribute[]): boolean => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every(
      (attr, index) =>
        attr.id === arr2[index].id &&
        attr.label === arr2[index].label &&
        attr.checked === arr2[index].checked &&
        attr.percentile === arr2[index].percentile
    );
  };

  const handleSelectedZoneChange = (zones: IZoneArray[] | undefined) => {
    if (zones !== undefined) {
      const zoneIds = zones.map((zone) => zone.id);
      handleSelectedPlayerZones(zoneIds);
      fetchPositionData(zoneIds);
      setSelectedPositionIds(zoneIds);
      setIsAltered(selectedAreas.length > 0 && !arraysEqual(zoneIds, selectedPlayerZones));
    }
    handleFilterChange("zoneChange", zones?.length! > 0);
  };

  useEffect(() => {
    handleFilterChange("zoneChange", selectedPlayerZones.length > 0);
  }, [selectedPlayerZones]);

  const updateSectionsState = (sectionTitle: string, id: string, updates: Partial<IAttribute>) => {
    const newSections = sectionsState.map((section) => {
      if (section.title === sectionTitle) {
        return {
          ...section,
          attributes: section.attributes.map((attr) => (attr.id === id ? { ...attr, ...updates } : attr)),
        };
      }
      return section;
    });
    setSectionsState(newSections);
    const selectedAttributelist = newSections.flatMap((section) => section.attributes).filter((attribute) => attribute.checked);
    handleSelectedAttributes(selectedAttributelist);
    handleSelectedPlayerAttributes(newSections);
    setIsAltered(!areAttributesEqual(selectedAttributelist, selectedAttributesState));
    handleFilterChange("attributeChange", selectedAttributelist.length > 0);
  };

  const handleCheckboxChange = (sectionTitle: string, id: string) => {
    updateSectionsState(sectionTitle, id, {
      checked: !sectionsState.find((section) => section.title === sectionTitle)?.attributes.find((attr) => attr.id === id)?.checked,
      isMadeUpScore: initialAttributeSections.length === 0 ? true : false,
    });
  };

  const handlePercentileChange = (sectionTitle: string, id: string, value: number) => {
    updateSectionsState(sectionTitle, id, { percentile: value, isMadeUpScore: initialAttributeSections.length === 0 ? true : false });
  };

  const handleTransferValueSliderChange = (min: number, max: number) => {
    setPlayerTransferValue({ min: min, max: max });
    setTransferValue({ min: min, max: max });
    handleFilterChange("transferValueSliderChange", min !== 0 || max !== 250000000);
  };
  const handleTrueValueSliderChange = (min: number, max: number) => {
    setPlayerTrueValue({ min: min, max: max });
    setTrueValue({ min: min, max: max });
    handleFilterChange("trueValueSliderChange", min !== 0 || max !== 250000000);
  }

  const handleContractValueSliderChange = (min: number, max: number) => {
    setPlayerContractUntilValue({ min: min, max: max });
    setContractUntilValue({ min: min, max: max });
    handleFilterChange("contractValueSliderChange", min !== 0 || max !== 120);
  };

  const handleWagesValueSliderChange = (min: number, max: number) => {
    setPlayerWagesValue({ min: min, max: max });
    setWagesValue({ min: min, max: max });
    handleFilterChange("wagesValueSliderChange", min !== 0 || max !== 180000000);
  };

  const handleAgeValueSliderChange = (min: number, max: number) => {
    setPlayerAgeRange({ min: min, max: max });
    setAgeRange({ min: min, max: max });
    handleFilterChange("ageValueSliderChange", min !== 16 || max !== 50);
  };

  const toggleSection = (section: keyof ISectionState) => {
    setIsOpen((prevState) => ({ ...prevState, [section]: !prevState[section] }));
  };

  const handleMinApperancesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length <= 5) {
      const newValue = event.target.value === "" ? 0 : parseInt(event.target.value);
      if (!isNaN(newValue)) {
        setPlayerMinAppearances(newValue);
        setMinAppearances(newValue);
        settxtInputWidth(Math.max(50, event.target.value.length * 20)); // Adjust width based on length
      }
    }
    handleFilterChange("minApperancesChange", event.target.value !== "");
  };

  const handleStatsOnly = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    handleFilterChange("statsOnly", !playerStartsOnly);
    event.stopPropagation();
    setPlayerStartsOnly(!playerStartsOnly);
    setStartsOnly(!playerStartsOnly);
  };

  const handleFootChange = (selectedFoot: any) => {
    const selectedOptionIds = selectedFoot.map((item: any) => item.optionId);
    setSelectedFootOptions(selectedOptionIds);
    setFoot(selectedOptionIds);
    handleFilterChange("footChange", selectedFoot.length > 0);
  };

  const handleSelectionClubLeagueChange = (selectedOptions: ISelectedOption[], region: string) => {
    setPlayerCompetition((prevRegion) => {
      // Group the roles by competition
      const rolesByRegion: Record<string, ISelectedOption[]> = {};
      prevRegion.forEach((competition) => {
        if (!rolesByRegion[competition.region]) {
          rolesByRegion[competition.region] = [];
        }
        rolesByRegion[competition.region].push(competition);
      });
      // Remove existing options from the same region
      selectedOptions.forEach((newOption) => {
        const existingOptions = rolesByRegion[newOption.region];
        if (existingOptions) {
          existingOptions.forEach((existingOption) => {
            const index = prevRegion.findIndex((area) => area.optionId === existingOption.optionId);
            if (index !== -1) {
              prevRegion.splice(index, 1);
            }
          });
        }
      });
      // Concatenate the unique options with the previous roles
      let updatedRegions = [...prevRegion];
      // If selectedOptions is empty, remove all options for the region
      if (selectedOptions.length === 0) {
        updatedRegions = updatedRegions.filter((area) => area.region !== region);
      } else {
        updatedRegions = [...updatedRegions, ...selectedOptions];
      }
      const competitionId = updatedRegions.map((comp) => comp.optionId);
      setCompetitionValues(updatedRegions);
      return updatedRegions;
    });
  };

  const handleSelectionRegionChange = (selectedOptions: ISelectedOption[], region: string) => {
    setPlayerRegion((prevRegion) => {
      const rolesByRegion: Record<string, ISelectedOption[]> = {};
      prevRegion.forEach((area) => {
        if (!rolesByRegion[area.region]) {
          rolesByRegion[area.region] = [];
        }
        rolesByRegion[area.region].push(area);
      });
      selectedOptions.forEach((newOption) => {
        const existingOptions = rolesByRegion[newOption.region];
        if (existingOptions) {
          existingOptions.forEach((existingOption) => {
            const index = prevRegion.findIndex((area) => area.optionId === existingOption.optionId);
            if (index !== -1) {
              prevRegion.splice(index, 1);
            }
          });
        }
      });
      let updatedRegions = [...prevRegion];
      if (selectedOptions.length === 0) {
        updatedRegions = updatedRegions.filter((area) => area.region !== region);
      } else {
        updatedRegions = [...updatedRegions, ...selectedOptions];
      }
      //const regionId = updatedRegions.map((reg) => reg.optionId);
      setRegionValues(updatedRegions);
      return updatedRegions;
    });
  };

  useEffect(() => {
    handleFilterChange("regionChange", regionValues.length > 0);
  }, [regionValues]);

  useEffect(() => {
    handleFilterChange("clubLeague", competitionValues.length > 0);
  }, [competitionValues]);

  const removeTag = (id: string) => {
    const tagList = selectedTags.filter((tag) => tag.id !== id);
    setSelectedPlayerTags(tagList);
    handleSelectedTags(tagList);
    handleFilterChange("tagsDataChange", tagList.length > 0);
  };

  const handleSearch = useCallback(
    debounceFunction(async (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      if (value.length >= 3) {
        setSearchText(value);
        startLoading();
        try {
          const response: IApiResponse<IPlayerSearchResponse[]> = await fetchDataForSearchPlayer(value);
          if (response.isSuccess) {
            setSearchPlayerData(response.data); // Update the state with the data array directly
          } else {
            console.error(response.error?.message || "Error fetching player data");
          }
        } finally {
          stopLoading();
        }
      } else {
        setSearchPlayerData?.([]);
      }
    }, 600), // Adjust the debounce delay (300ms in this case) as needed
    []
  );

  const handleClear = () => {
    setSearchText("");
    setSearchPlayerData?.([]);
  };

  const handleSelectPlayer = (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => {
    handleFilterChange("selectPlayer", selectedPlayers.length === 0);
    if (item !== null && Array.isArray(item)) {
      handleSelectedPlayer(item);
      fetchPlayerZonePosition(item[0].playerId);
      fetchAttributesData(item[0].playerId, selectedOption);
      handleClear();
    }
  };

  const renderProfileItems = useMemo(() => {
    return zonePositionList.map((position) => <PlayerPositionProfile key={position.positionName} item={position} />);
  }, [zonePositionList]);

  const renderSearchPlayers = () => {
    return (
      searchPlayerData?.length > 0 && (
        <InitialSearchPlayerList className="search-player-list">
          <PlayerSearchList
            searchData={searchPlayerData}
            searchText={searchText}
            onSelect={handleSelectPlayer}
            selectedItems={selectedItems}
            multiSelection={false}
            iconType="image"
            displayCheckBox={false}
          />
        </InitialSearchPlayerList>
      )
    );
  };

  const removePlayer = (playerId: number) => {
    const updatedPlayers = selectedPlayers.filter((player) => player.playerId !== playerId);
    handleSelectedPlayer(updatedPlayers);
    handleFilterChange("selectPlayer", selectedPlayers.length === 0);
  };

  const renderSelectedPlayers = useCallback(() => {
    return selectedPlayers.map((player) => (
      <SelectedPlayerResult key={player.playerId} className="selected-player-result">
        <div className="selected-player-result-content">
          <PlayerAvatar className="selected-player-image" backgroundImage={player.playerImageURL} />
          <div className="selected-player-fullname">
            <LabelText className={player?.isEasternPlayer ? "drawer-title" : "player-given-name"}>
              {player?.isEasternPlayer ? player?.familyName : player?.givenName}
            </LabelText>
            <LabelText className={player?.isEasternPlayer ? "player-given-name" : "drawer-title"}>
              {player?.isEasternPlayer ? player?.givenName : player?.familyName}
            </LabelText>
          </div>
          <ForawrdBackwardButton onClick={() => removePlayer(player.playerId)}>
            <CloseIcon className="cta-btn-icons" />
          </ForawrdBackwardButton>
        </div>
        {isAltered && (
          <AlteredSection className="altered-section">
            <img src={theme.mode === "light" ? AlteredIcon : GreenAlteredIcon} className="altered-icon" alt="Altered Icon" />
            <LabelText className="altered-text">Altered</LabelText>
          </AlteredSection>
        )}
      </SelectedPlayerResult>
    ));
  }, [selectedPlayers, removePlayer, isAltered]);

  const handlePlayerSearch = () => {
    setIsPlayerSearch(!isPlayerSearch);
    handleClear();
  };

  const fetchPositionData = async (zoneIds: number[]) => {
    if (zoneIds.length > 0) {
      startLoading();
      try {
        const requestParameters = { zoneIds: zoneIds };
        const response: IApiResponse<IPositionSearchByZoneResponse[]> = await postData(apiUrls.SearchPositionbyZone, requestParameters);
        if (response.isSuccess) {
          setZonePositionList(response.data);
          setSelectedProfileItems(response.data);
          setAllProfiles(response.data);
          const positionIdsArray: number[] = response.data.map((position) => position.positionId);
          handleSelectedProfiles(positionIdsArray);
        }
      } finally {
        stopLoading();
      }
    } else {
      setZonePositionList([]);
    }
  };

  const handleProfileSelect = (item: IPositionSearchByZoneResponse | IPositionSearchByZoneResponse[] | null, selected: boolean) => {
    if (item === null && selected === false) {
      setSelectedProfileItems([]);
    } else if (Array.isArray(item)) {
      setSelectedProfileItems(item);
      const positionIdsArray: number[] = item.map((position) => position.positionId);
      handleSelectedProfiles(positionIdsArray);
      const isEqual = arraysEqual(positionIdsArray, selectedProfiles);
      if (selectedProfileItems.length > 0 && zonePositionList.length > 0 && !isEqual) setIsAltered(true);
      else setIsAltered(false);
    } else if (item !== null && !Array.isArray(item)) {
      setSelectedProfileItems((prevItems) =>
        selected ? [...prevItems, item!] : prevItems.filter((selectedItem) => selectedItem.positionName !== item!.positionName)
      );
    }
    handleFilterChange("profileSelect", selectedProfileItems.length === 0);
  };

  const renderAttributeSections = () => {
    return sectionsState.map((section) => (
      <div key={section.title} className="section">
        <LabelText className="team-selection-text">{section.title}</LabelText>
        <div className="player-filter-attribute-section-list">
          {section.attributes.map((attr) => (
            <AttributesList key={attr.id} checked={attr.checked} className="attribute-item attribute-content">
              <Switch
                id={attr.id}
                toggled={attr.checked}
                onChange={() => handleCheckboxChange(section.title, attr.id)}
                source="Filter"
                title={attr.displayName}
                isByComparison={false}
              />
              <div className={`percentile-box   ${attr.checked ? "selected-attributes" : "unselected-attributes"}`}>
                <NumberTextField
                  maxLength={attr.id === "Height Cm" ? 3 : 5}
                  value={attr.id === "Height Cm" ? attr.percentile : attr.percentile?.toFixed(2)}
                  onChange={(e) => handlePercentileChange(section.title, attr.id, parseFloat(e.target.value) || 0)}
                  id={attr.id}
                />
              </div>
            </AttributesList>
          ))}
        </div>
      </div>
    ));
  };

  const handleTagConfirm = (selectedData: ITag[]) => {
    setSelectedPlayerTags(selectedData);
    handleSelectedTags(selectedData);
    handleFilterChange("tagsDataChange", selectedData.length > 0);
  };

  const fetchPlayerZonePosition = async (playerId: number) => {
    startLoading();
    try {
      const response: IApiResponse<IPlayerZonePosition> = await fetchPlayerZonePositionData(playerId);
      if (response.isSuccess) {
        const playerZonePositionData = response.data;
        setSelectedAreas(playerZonePositionData?.zones || []);
        handleSelectedPlayerZones(playerZonePositionData?.zones || []);
        const allPositionList = playerZonePositionData?.position?.playerPositions || [];
        setZonePositionList(allPositionList);
        setAllProfiles(allPositionList);
        const selectedProfileItems = playerZonePositionData?.position?.selectedPosition || [];
        const filteredPositions = allPositionList.filter((position) => selectedProfileItems.includes(position.positionId));
        setSelectedProfileItems(filteredPositions);
        const positionIdsArray: number[] = filteredPositions.map((position) => position.positionId);
        handleSelectedProfiles(positionIdsArray);
      } else {
        console.error(response.error?.message || "Error fetching player zone position data");
      }
    } finally {
      stopLoading();
    }
  };

  const fetchAttributesData = async (playerId: number, selectedPositionOption: string) => {
    startLoading();
    try {
      const requestParameters = {
        playerId: playerId,
        AllPosition: selectedPositionOption === "allpositions",
        AttributeScoreFor: "universe",
        seasonId: 0,
      };
      const response: IApiResponse<IPlayerAttributesData> = await postData(apiUrls.GetPlayerAttributes, requestParameters);
      if (response.isSuccess) {
        const attributesData = response.data;
        const playerAttributesUniverse = attributesData.playerAttributesUniverseTheirPos;
        const updatedSections = attributeSections.map((section) => ({
          ...section,
          attributes: section.attributes.map((attribute) => {
            let score: number | null = null;
            switch (attribute.id) {
              case "Height Cm":
                score = attributesData.heightInCM;
                break;
              case "Av. contribution score":
                score = playerAttributesUniverse.overall.performanceValue;
                break;
              case "finishing-shots":
                score = playerAttributesUniverse.finalThird.finishingShots.score;
                break;
              case "finishing-aerial":
                score = playerAttributesUniverse.finalThird.finishingAerial.score;
                break;
              case "attack-positioning":
                score = playerAttributesUniverse.finalThird.attackPositioning.score;
                break;
              case "creativity":
                score = playerAttributesUniverse.buildUpPlay.creativity.score;
                break;
              case "passing-accuracy":
                score = playerAttributesUniverse.buildUpPlay.passingAccuracy.score;
                break;
              case "dribbling":
                score = playerAttributesUniverse.buildUpPlay.dribbling.score;
                break;
              case "crossing":
                score = playerAttributesUniverse.buildUpPlay.crossing.score;
                break;
              case "tackling":
                score = playerAttributesUniverse.defence.tackling.score;
                break;
              case "defensive-headers":
                score = playerAttributesUniverse.defence.defensiveHeaders.score;
                break;
              case "aggression":
                score = playerAttributesUniverse.defence.aggression.score;
                break;
              default:
                return attribute; // If no match, return the original attribute
            }
            return {
              ...attribute,
              checked: score !== null && score !== 0, // Set checked to true only if score is not null and not 0
              percentile: score,
            };
          }),
        }));
        setSectionsState(updatedSections);
        handleSelectedPlayerAttributes(updatedSections);
        setInitialAttributeSections(updatedSections);
        setPlayerInitialAttributes(updatedSections);
        const selectedAttributelist = updatedSections.flatMap((section) => section.attributes).filter((attribute) => attribute.checked);
        handleSelectedAttributes(selectedAttributelist);
        setIsSearchByAttributes(selectedAttributelist.length > 0 ? true : false);
        handleFilterChange("attributeChange", selectedAttributelist.length > 0);
      }
    } finally {
      stopLoading();
    }
  };

  const handleCreateList = () => {
    if (initialAttributeSections.length > 0) {
      const updatedSections = sectionsState.map((section, sectionIndex) => {
        const updatedAttributes = section.attributes.map((attr, attrIndex) => {
          const initialAttr = initialAttributeSections[sectionIndex].attributes[attrIndex];
          return {
            ...attr,
            isMadeUpScore: attr.percentile !== initialAttr.percentile, // Compare with initial values
          };
        });
        return { ...section, attributes: updatedAttributes };
      });
      const selectedAttributelist = updatedSections.flatMap((section) => section.attributes).filter((attribute) => attribute.checked);
      handleSelectedAttributes(selectedAttributelist);
    } else {
      const selectedAttributelist = sectionsState.flatMap((section) => section.attributes).filter((attribute) => attribute.checked);
      handleSelectedAttributes(selectedAttributelist);
    }
    setPlayerSearchResultsVisible(true);
    setIsPlayerFilterChange(true);
    navigate("/playersearchresult");
  };

  const anyAttributeChecked = sectionsState.flatMap((section) => section.attributes).some((attribute) => attribute.checked);

  const handleTurnAllOffClick = () => {
    const updatedSections = attributeSections.map((section) => ({
      ...section,
      attributes: section.attributes.map((attribute) => {
        switch (attribute.id) {
          case "Height Cm":
            return { ...attribute, checked: false };
          case "Av. contribution score":
            return { ...attribute, checked: false };
          case "finishing-shots":
            return { ...attribute, checked: false };
          case "finishing-aerial":
            return { ...attribute, checked: false };
          case "attack-positioning":
            return { ...attribute, checked: false };
          case "creativity":
            return { ...attribute, checked: false };
          case "passing-accuracy":
            return { ...attribute, checked: false };
          case "dribbling":
            return { ...attribute, checked: false };
          case "crossing":
            return { ...attribute, checked: false };
          case "tackling":
            return { ...attribute, checked: false };
          case "defensive-headers":
            return { ...attribute, checked: false };
          case "aggression":
            return { ...attribute, checked: false };
          default:
            return attribute; // If no match, return the original attribute
        }
      }),
    }));
    setSectionsState(updatedSections);
    handleSelectedPlayerAttributes(updatedSections);
    handleFilterChange("attributeChange", !anyAttributeChecked);
  };

  const handlePositionChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedOption(e.target.value);
      if (selectedPlayers && selectedPlayers.length > 0 && selectedPlayers[0].playerId) {
        fetchAttributesData(selectedPlayers[0].playerId, e.target.value);
      }
    },
    [selectedPlayers, fetchAttributesData]
  );

  const handleExactMatchToggle = () => {
    setIsExactMatch((prev) => !prev);
    setIsExactMatchesOnly(!isExactMatch);
  };

  const handleArchetypeToggle = (switchingID: number) => {
    if (selectedProfiles?.includes(switchingID)) {
      setSelectedProfiles((prev) => prev.filter((id) => id !== switchingID));
    } else {
      setSelectedProfiles((prev) => [...prev, switchingID]);
    }
  };

  const heatSignatureRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number>(0);
  useEffect(() => {
    if (heatSignatureRef.current) {
      setContainerWidth(heatSignatureRef.current.clientWidth);
    }
  }, [activeArchetypeID]);

  const handleArchetypeClick = (archId: number, archName: string) => {
    if (activeArchetypeID === archId) {
      setActiveArchetypeID(0);
    } else {
      setActiveArchetypeID(archId);
      setActiveArchetypeName(archName)
    }
  };

  const hanldeInfoClick = (archId: number, archName: string) => {
    setSidebarOpen(true)
    setArchetypeID(archId);
    setActiveArchetypeName(archName)

  };

  const [worksWellWith, setWorksWellWith] = useState<IWorksWellWith[]>([]);

  const [footPrints, setFootPrints] = useState<IWorksWellWith[]>([]);
  const [typicalPlayerExamples, setTypicalPlayerExamples] = useState<ITypicalPlayerExample[]>([]);
  const [playerPScore, setPlayerPScore] = useState<IComparisonData>({});
  const [playerRaw, setPlayerRaw] = useState<IComparisonData>({});
  const [activeComparisonArchetype, setActiveComparisonArchetype] = useState<number | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);


  useEffect(() => {
    const fetchArchetypeInfoData = async () => {
      try {
        setIsLoading(true);
        const response: IApiResponse<IArchetypeInfo> = await fetchData(`${apiUrls["GetArchetypeDetails"]}/${activeArchetypeID}`);
        if (response.isSuccess) {
          setIsLoading(false);
          setWorksWellWith(response?.data?.worksWells);
          setTypicalPlayerExamples(response?.data?.typicals);
          setWorksWellWith(response?.data?.worksWells);
          setTypicalPlayerExamples(response?.data?.typicals);
          setPlayerPScore(response?.data?.selectedPscore);
          setPlayerRaw(response?.data?.selectedRaw);
          setActiveComparisonArchetype(response?.data?.footPrints?.[0]?.archetypeId);
          setFootPrints(response?.data?.footPrints)
          return response;
        }
      } catch (error) {
        setIsLoading(false);
        return console.log("500", "API call failed due to an internal server error");
      }
    };
    if (activeArchetypeID !== 0) {
      fetchArchetypeInfoData();
    }
  }, [activeArchetypeID]);

  useEffect(() => {
    if (selectedPlayers?.length > 0) {
      if (selectedProfiles?.length === 1) {
        setActiveArchetypeID(selectedProfiles[0]);
      }
    }
  }, [selectedPlayers, selectedProfiles]);

  return (
    <>
      <div className="player-filters-wrapper">
        <PlayerFilterText className="player-filter-text">
          <LabelText className="drawer-title">Create a player list</LabelText>
        </PlayerFilterText>
        <div className="player-filters-content">
          <div className="player-filters-left">
            <PlayerFilterText className="search-player">
              <div className="filters-by-player">
                <LabelText className="player-filter-labeltext">Use player as a benchmark</LabelText>
                <Switch id="player-search" toggled={isPlayerSearch} onChange={handlePlayerSearch} source="Filter" isByComparison={false} />
              </div>
              {selectedPlayers.length > 0 && isPlayerSearch
                ? renderSelectedPlayers()
                : isPlayerSearch && (
                  <div className="player-search-content-only">
                    <SearchInput
                      handleSearch={handleSearch}
                      handleClear={handleClear}
                      placeholder="Search player"
                      fontSize="20px"
                      type="SearchPlayer"
                      clearInput={clearInput}
                      autoFocus={false}
                    />
                    {renderSearchPlayers()}
                  </div>
                )}
            </PlayerFilterText>
            <PlayerFilterText className="filters-by-zone">
              <div className="filter-zone-header">
                <LabelText className="player-filter-labeltext">Zones of play</LabelText>
                <LabelText>Select the parts of the pitch you’re interested in.</LabelText>
                {/* {zonePositionList.length > 0 && (
                  <div className="filter-profile-list">
                    <CustomList<IPositionSearchByZoneResponse>
                      selectedItems={selectedProfileItems}
                      onSelect={handleProfileSelect}
                      multiSelection={true}
                      isCheckBox={true}
                      showSelectAllCheckbox={true}
                      isDropdown={true}
                    >
                      {renderProfileItems}
                    </CustomList>
                  </div>
                )} */}
              </div>
              <div className="filter-zone-pitch">
                <Pitch
                  isPattern={false}
                  isCorner={false}
                  isZones
                  onSelectedZonesChange={handleSelectedZoneChange}
                  selectedZones={selectedAreas}
                />
              </div>
            </PlayerFilterText>
            <div>
              <LabelText className="player-filter-labeltext">Roles</LabelText>
              {zonePositionList?.length === 0 && <div className="role-initiator">Select a zone of play</div>}
              {zonePositionList?.length > 0 && (
                <div className="archetype-individuals-container">
                  {allProfiles?.map((arch) => (
                    <div
                      className={`archetype-individuals ${activeArchetypeID === arch?.positionId ? "expanded" : ""}`}
                      style={{ backgroundColor: selectedProfiles?.includes(arch?.positionId) ? "#F2F5EE" : "#F9FAF7" }}
                    >
                      <div className="switch-container">
                        <Switch
                          id={arch?.positionId.toString()}
                          toggled={selectedProfiles?.includes(arch?.positionId)}
                          onChange={() => handleArchetypeToggle(arch?.positionId)}
                          source="Filter"
                          isByComparison={false}
                        />
                      </div>
                      <div className="archetype-individuals-content" >
                        <div className="archtype-info-icon">
                          <LabelText className="player-detail-given-name">{arch?.positionName}</LabelText>
                          <div className='attributesonpitch-info-icon' style={{ position: 'static', zIndex: 0 }}>
                            <img src={InfoIcon} alt="archetpe-info" className="archetype-info-icon" onClick={() => hanldeInfoClick(arch?.positionId, arch?.positionName)} />
                          </div>
                        </div>

                        {activeArchetypeID === arch?.positionId && (
                          <div className="archetype-individuals-info-container">
                            <div className="individuas-pitch-player-conatiner">
                              {isLoading && <ModuleSpinner />}
                              <div className="typical-exmaples-container">
                                <p>Typical examples</p>
                                <div className="individual-typical-player-container">
                                  {typicalPlayerExamples?.map((example) => (
                                    <div className="individual-typical-player">
                                      <img src={example?.imageUrl} alt="playerImage" />
                                      <div>
                                        <p className="typical-player-name">{example?.shortName}</p>
                                        <p className="typical-player-club">{example?.teamName}</p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div className="typical-heat-signature-container" ref={heatSignatureRef}>
                                {/* <Pitch isPattern={false} width={containerWidth || 200} /> */}
                                <p>Works well with...</p>
                                <div>
                                  {worksWellWith?.map((work) => (
                                    <div style={{ backgroundColor: getArchetypeColorByValue(work?.score) }} className="work-archetype">
                                      {work?.archetypeName}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                            <div>
                              <p className="role-comparison-header">Compared to other roles</p>
                              <div className="archetype-chart-container">
                                <ArchetypeComparisonChart
                                  data={playerPScore || {}}
                                  rawData={playerRaw || {}}
                                  comparisonData={
                                    footPrints?.find((segment) => segment?.archetypeId === activeComparisonArchetype)?.footprintPscore!
                                  }
                                  width={250}
                                  height={250}
                                />
                                <div className="side-container-comparison-archetype">
                                  {worksWellWith?.length > 0 && (
                                    <div className="archetype-selected-segement">
                                      <ColorBox color={archetypeCircleColors[0]} />
                                      <div className="archetype-selected-segement-text">{arch?.positionName}</div>
                                    </div>
                                  )}

                                  {footPrints?.map((archetype) => (
                                    <div
                                      key={archetype.archetypeId}
                                      className="archetype-radio-item"
                                      onClick={(event) => {
                                        event?.stopPropagation();
                                        setActiveComparisonArchetype(
                                          activeComparisonArchetype === archetype.archetypeId ? null : archetype.archetypeId
                                        );
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        id={`archetype-${archetype.archetypeId}`}
                                        name="archetype-comparison"
                                        checked={activeComparisonArchetype === archetype.archetypeId}
                                      />
                                      <label htmlFor={`archetype-${archetype.archetypeId}`}>{archetype.archetypeName}</label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div className="archetype-segement-container">
                                {Object.entries(playerPScore)
                                  .filter(([_, value]) => value !== null)
                                  .map(([key, _], index) => (
                                    <div key={key} className="archetype-segment-item">
                                      <ColorBox color={archetypeCircleColors[index % archetypeCircleColors.length]} />
                                      <div className="archetype-segement-text">
                                        {key
                                          .replace(/([A-Z])/g, " $1")
                                          .trim()
                                          .toUpperCase()}
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="chevron-archetype" onClick={() => handleArchetypeClick(arch?.positionId, arch?.positionName)}>
                          {activeArchetypeID === arch?.positionId ? (
                            <img src={ChevronUp} alt="close-info" />
                          ) : (
                            <img src={ChevronDown} alt="open-info" />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="filters-by-attributes">
              <LabelText className="player-filter-labeltext">Attributes</LabelText>
              <SelectedPlayerResult className="player-filter-positions">
                <LabelText>Scored in relation to...</LabelText>
                <div className="players-position-radiobutton-group">
                  {positionOptions.map((option) => (
                    <RadioButton
                      key={option.value}
                      label={option.label}
                      name={option.label}
                      value={option.value}
                      checked={selectedOption === option.value}
                      onChange={handlePositionChange}
                    />
                  ))}
                </div>
              </SelectedPlayerResult>
              <div className="player-filter-attributes-list">{renderAttributeSections()}</div>
              <SecondaryButton
                label="TURN ALL OFF"
                onClick={handleTurnAllOffClick}
                className="turn-all-off-btn"
                disabled={!anyAttributeChecked}
              />
            </div>
          </div>
          <div className="player-filters-right">
            <div>
              
              <LabelText className="player-filter-labeltext">Market value €</LabelText>
              <div className="market-value-filter">
                <BarChart
                  data={valueSliderData}
                  onDataUpdate={handleTransferValueSliderChange}
                  initialMinValue={0}
                  initialMaxValue={250000000}
                  defaultSelectedValue={[playerTransferValue.min, playerTransferValue.max]}
                  isFor={"Transfer Value"}
                />
              </div>
              <LabelText className="player-filter-labeltext">True Value</LabelText>
              <div className="market-value-filter">
                <BarChart
                  data={valueSliderData}
                  onDataUpdate={handleTrueValueSliderChange}
                  initialMinValue={0}
                  initialMaxValue={250000000}
                  defaultSelectedValue={[playerTrueValue.min, playerTrueValue.max]}
                  isFor={"Transfer Value"}
                />
              </div>
              <LabelText className="player-filter-labeltext">Age</LabelText>
              <div className="age-filter">
                <BarChart
                  data={valueSliderData}
                  onDataUpdate={handleAgeValueSliderChange}
                  initialMinValue={16}
                  initialMaxValue={50}
                  defaultSelectedValue={[playerAgeRange.min, playerAgeRange.max]}
                />
              </div>
              <Section label="Other financial" isOpen={isOpen.financial} toggle={() => toggleSection("financial")}>
                <div className="section-content">
                  <BarChart
                    header="WAGES €"
                    data={wagesSliderData}
                    onDataUpdate={handleWagesValueSliderChange}
                    initialMinValue={0}
                    initialMaxValue={180000000}
                    defaultSelectedValue={[playerWagesValue.min, playerWagesValue.max]}
                    isFor={"Transfer Value"}
                  />
                  <BarChart
                    header="contract - months left"
                    data={wagesSliderData}
                    onDataUpdate={handleContractValueSliderChange}
                    initialMinValue={0}
                    initialMaxValue={120}
                    defaultSelectedValue={[playerContractUntilValue.min, playerContractUntilValue.max]}
                  />
                </div>
              </Section>
              <Section label="Mins played" isOpen={isOpen.statistical} toggle={() => toggleSection("statistical")}>
                <div className="section-content">
                  <Foot>
                    <div className="starts-only">
                      <LabelText className="team-selection-text">Min. mins played</LabelText>
                      <InputFeild
                        //placeholder="0"
                        maxLength={5}
                        value={playerMinAppearances}
                        onChange={handleMinApperancesChange}
                        id="minsPlayed"
                        style={{
                          width: `${txtInputWidth}px`,
                          transition: "width 0.2s ease",
                        }}
                      />
                    </div>
                    <div className="starts-only">
                      <LabelText>Starts only</LabelText>
                      <Switch
                        id="starts-only"
                        toggled={playerStartsOnly}
                        onChange={handleStatsOnly}
                        source="Filter"
                        isByComparison={false}
                      />
                    </div>
                  </Foot>
                </div>
              </Section>
              <Section label="Preferred foot" isOpen={isOpen.Preferredfoot} toggle={() => toggleSection("Preferredfoot")}>
                <FilterDropdown
                  region={"All options"}
                  options={footLabels}
                  defaultSelectedOptions={selectedFootOptions.filter((item) => item).map((item) => item)}
                  onChange={handleFootChange}
                  includeAll={true}
                  displayAsDropdown={true}
                  isDisplaySearch={false}
                />
              </Section>
              <Section label="Club league" isOpen={isOpen.clubleague} toggle={() => toggleSection("clubleague")}>
                {clubLeagueData?.map((comp) => (
                  <FilterDropdown
                    key={comp.region}
                    region={comp.region}
                    options={comp.competitions}
                    type={comp.region}
                    onChange={handleSelectionClubLeagueChange}
                    defaultSelectedOptions={playerCompetition.filter((item) => item.region === comp.region).map((item) => item.optionId)}
                    includeAll={true}
                    displayAsDropdown={true}
                  />
                ))}
              </Section>
              <Section label="Nationality" isOpen={isOpen.region} toggle={() => toggleSection("region")}>
                {regionAreaData?.map((regionItem) => (
                  <FilterDropdown
                    key={regionItem.region}
                    region={regionItem.region}
                    options={regionItem.areas}
                    type={regionItem.region}
                    onChange={handleSelectionRegionChange}
                    defaultSelectedOptions={playerRegion.filter((item) => item.region === regionItem.region).map((item) => item.optionId)}
                    includeAll={true}
                    displayAsDropdown={true}
                  />
                ))}
              </Section>
              <Section label="Tags" isOpen={isOpen.tags} toggle={() => toggleSection("tags")}>
                <div className="top-percentiles">
                  {selectedPlayerTags.length === 0 && <LabelText>Add any tags of importance.</LabelText>}
                  <PrimaryButton
                    label={selectedPlayerTags.length > 0 ? "Add more" : "Add tags"}
                    iconType="add"
                    onClick={() => {
                      setTagsDrawerOpen(true);
                    }}
                  />
                  {selectedPlayerTags.length > 0 &&
                    selectedPlayerTags.map((tag, index) => (
                      <SelectedAttributes key={index} className="selected-filter-attributes">
                        <LabelText className="squad-chart-tooltip">{tag.label}</LabelText>
                        <div className="selected-attributes-percentiles">
                          <CloseIcon className="cta-btn-icons" onClick={() => removeTag(tag.id)} />
                        </div>
                      </SelectedAttributes>
                    ))}
                </div>
              </Section>
            </div>
          </div>
        </div>
        <PlayerSearchResultsStyled className="player-search-profile-result">
          <div className="search-results-content">
            <div className="player-exact-matches">
              <LabelText>Exact matches only</LabelText>
              <Switch id="exact-match" toggled={isExactMatch} onChange={handleExactMatchToggle} source="Filter" isByComparison={false} />
            </div>
            <PrimaryButton label="Create list" onClick={handleCreateList} />
          </div>
        </PlayerSearchResultsStyled>
      </div>
      <SelectTags
        isOpen={tagsDrawerOpen}
        onClose={() => setTagsDrawerOpen(false)}
        onConfirm={handleTagConfirm}
        selectedTag={selectedPlayerTags}
      />
      <ArchetypeInfoDrawer
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        //archetypeName={archetypeData[0]?.archetypeName!}
        //activeArchetypeID={archetypeData[0]?.archetypeId!}
        archetypeName={activeArchetypeName}
        activeArchetypeID={archetypeID}
      />
    </>
  );
};

export default React.memo(PlayerSearchInit);
